import Drum from "../images/Drum.png";
import Choir from "../images/Choir.png";
import Headphone from "../images/Headphone.png";
import { useState, useEffect, useRef } from 'react';
import '../styles/Home.css';
import TopNavBar from "../components/TopNavBar";

//The home page.
const Home = () => {

    //State to hold the current word.
    const [currentWord, setCurrentWord] = useState("courage");

    //State to hold the next word.
    const [nextWord, setNextWord] = useState("")

    //State to hold the index of the word array.
    const [wordIdx, setWordIdx] = useState(0);

    //The array of words to use.
    const words = ["courage", "love", "knowledge", "teamwork", "friendship", "hard work", "effort"]

    //Reference to the kindwWord element.
    const kindWord = useRef(null);

    //Effect to swap the words periodically.
    useEffect(() => {

        kindWord.current.addEventListener('animationstart', (ev) => {
            //Timer to count down when to pause the animation.
            const c = setTimeout(() => {

                kindWord.current.style.animationPlayState = "paused";


                //Timer to restart the animation.
                const d = setTimeout(() => {
                    kindWord.current.style.animationPlayState = 'running';
                }, [3000])

            }, [1000]);

            //Set the current word.
            setCurrentWord(words[Math.floor(ev.elapsedTime % 7)]);

            //Free the timeout when no longer needed.
            return () => clearTimeout(c);
        });

        //When the animation finishes.
        kindWord.current.addEventListener('animationiteration', (ev) => {

            //Timer to count down when to pause the animation.
            const c = setTimeout(() => {

                kindWord.current.style.animationPlayState = "paused";


                //Timer to restart the animation.
                const d = setTimeout(() => {
                    kindWord.current.style.animationPlayState = 'running';
                }, [3000])

            }, [1000]);
            //Set the current word.
            setCurrentWord(words[Math.floor(ev.elapsedTime % 7)]);

            //Free the timeout when no longer needed.
            return () => clearTimeout(c);

        });
    }, []);

    return (

        <div id="home">

            <header id="homeHeader">

                <section className="headerTitle">
                    <TopNavBar />

                    <h1 className="threeD">3D</h1>

                    <h3 className="musicAcademy">Music Academy Inc.</h3>

                </section>

                <section className="headerPitch">

                    <div className="pitchTextContainer">

                        <div id="pitchText">All music starts with&nbsp;<em id="kindWord" ref={kindWord}>{currentWord}</em>.</div>

                        <p id="pitchSubtext">Let us give you a strong musical foundation with our in-depth lessons that teach the fundamentals.</p>

                    </div>

                    <div className="pitchButtons">

                        <button id="learnMoreButton">Learn More</button>

                        <button id="contactUsButton">Talk to us</button>

                    </div>

                </section>

                <section id="headerFeatures">

                    <div className="feature">

                        <p className="featureTitle">Convenience</p>

                        <blockquote className="featureQuote">With us we can work around your schedule, and help you find the time best for you.</blockquote>

                    </div>

                    <div className="feature">

                        <p className="featureTitle">Experience</p>

                        <blockquote className="featureQuote">Our teachers are some of the greatest talents in Connecticut.</blockquote>

                    </div>

                    <div className="feature">

                        <p className="featureTitle">Location</p>

                        <blockquote className="featureQuote">Select where you study at from any of our brand new facilities located around Connecticut</blockquote>

                    </div>

                    <div className="feature">

                        <p className="featureTitle">Personalization</p>

                        <blockquote className="featureQuote">Courses are 1 on 1 and tailored to each student's learning style.</blockquote>

                    </div>

                </section>

            </header>

            <main id="appMain">

                <section id="detailsSection">

                    <div className="detailedContent">

                        <div className="contentImageContainer">

                            <img id="contentImage" src={Drum}></img>

                        </div>

                        <div className="contentTextContainer">

                            <p className="contentTitle">Develop an extra curricular gift</p>

                            <blockquote className="contentDetails">With our 6 week course, your child will develop skills that can benefit them creatively and emotionally.</blockquote>

                        </div>

                    </div>

                    <div className="detailedContent">

                        <div className="contentTextContainer">

                            <p className="contentTitle">Help your child build their voice</p>

                            <blockquote className="contentDetails">Our 6 week course is designed to help your child leadership, teamwork, and to play various instruments.</blockquote>

                        </div>

                        <div className="contentImageContainer">

                            <img id="contentImage" src={Choir}></img>

                        </div>

                    </div>

                    <div className="detailedContent">
                        <div className="contentImageContainer">

                            <img id="contentImage" src={Headphone}></img>

                        </div>

                        <div className="contentTextContainer">

                            <p className="contentTitle">Gain a deeper understanding of music</p>

                            <blockquote className="contentDetails">Our instructors will teach your child the deeper meaning of music and its theory.</blockquote>

                        </div>

                    </div>

                </section>

            </main>

            <footer id="appFooter">

                <section id="closingContainer">

                    <div className="ctaContainer">

                        <p id="callToAction">Ready to get started?</p>

                    </div>

                    <div className="ctaContainer">

                        <button id="ctaButton">Get Started</button>

                    </div>

                </section>
                <p>© 2022 3D Music Academy Inc.</p>
            </footer>

        </div>
    );
}

export default Home;